import React, { useEffect, useState } from "react";
import Select from "react-select";
import DatePicker from "react-datepicker";
import { format } from "date-fns";
import "../../Assets/Css/AddUpdateTransaction.scss";
import { customStyle } from "../../Components/Style";
import Sidebarlayout from "../../Layouts/Sidebarlayout";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { getShareholdersList } from "../../Services/Shareholders/action";
import { connect } from "react-redux";
import { getInvoicesList } from "../../Services/Invoices/action";
import {
  addTransaction,
  updateTransaction,
} from "../../Services/Transactions/action";
import { getSpendList } from "../../Services/Spends/action";
import { Spinner } from "react-bootstrap";
import { FaTrashAlt } from "react-icons/fa";
import moment from "moment";

const initialDataFormData = { description: "", type: "", amount: "", transaction_date: null };

const optionType = [
  { value: "credit", label: "Credit" },
  { value: "debit", label: "Debit" },
];

const AddUpdateTransaction = (props) => {
  const location = useLocation();
  const defaultData = location.state?.data;
  console.log(defaultData, ' <== I am default data..')
  const navigate = useNavigate();

  const [formData, setFormData] = useState(initialDataFormData);
  let [shareHolderOption, setShareHolderOption] = useState([]);
  const [selectedShareHolder, setSelectedShareHolder] = useState([]);
  const [deletedShareHolder, setDeletedShareHolder] = useState([]);

  let [invoicesOption, setInvoicesOption] = useState([]);
  const [selectedInvoices, setSelectedInvoices] = useState([]);
  const [deletedInvoices, setDeletedInvoices] = useState([]);

  let [spendsOption, setSpendsOption] = useState([]);
  const [selectedSpends, setSelectedSpends] = useState([]);
  const [deletedSpends, setDeletedSpends] = useState([]);

  const [isUpdate, setIsUpdate] = useState(false);
  let [remainingAmount, setRemainingAmount] = useState(0);
  let [invoiceRemainingAmount, setInvoiceRemainingAmount] = useState(0);
  let [spendRemainingAmount, setSpendRemainingAmount] = useState(0);

  const getShareHoldersForSelect = async () => {
    try {
      await props.getShareholdersList();
    } catch (error) {
      console.log("Error while Getting ShareHodlers List");
    }
  };
  const getInvoicesForSelect = async () => {
    try {
      await props.getInvoicesList();
    } catch (error) {
      console.log("Error while Getting Invoices List");
    }
  };
  const getSpendsForSelect = async () => {
    try {
      await props.getSpendList();
    } catch (error) {
      console.log("Error while Getting Spend List");
    }
  };

  useEffect(() => {
    getShareHoldersForSelect();
    getInvoicesForSelect();
    getSpendsForSelect();
    if (defaultData?.transactionId?.value) setIsUpdate(true);
    else if (defaultData?.transactionId.value === undefined && isUpdate) {
      toast.error("Something went wrong");
      navigate("/transaction");
    }
  }, []);

  const options = () =>
    props.shareholdersList?.map((items) => {
      return {
        value: { id: items.id, transAmount: 0 },
        label: items.name,
      };
    });
  const optionForInvoice = () => props.invoicesList?.map((items) => {
    return {
      value: { id: items.id, transInvoiceAmount: 0 },
      label: items.title,
    };
  });
  const optionForSpends = () => props.spendList?.map((items) => {
    return {
      value: { id: items.id, transSpendAmount: 0 },
      label: items?.name,
    };
  })

  useEffect(() => {
    if (defaultData?.transactionId.value) {
      setFormData({
        ...formData,
        description: defaultData?.Description?.value || "",
        amount: defaultData?.Amount?.value?.slice(1),
        type: optionType.find(
          (option) => option.value === defaultData?.Type?.type
        ),
        transaction_date: moment(defaultData?.Transaction_Date?.value, 'DD/MM/YYYY').toDate() || null,
      });
    }
  }, [defaultData]);

  useEffect(() => {
    const getOpt = options();
    if (isUpdate) {
      let shIds = defaultData["Share Holders"]?.value?.map((item) => item.id);
      let newUpdatedSh = getOpt?.filter((item) =>
        shIds.includes(item.value.id)
      );
      let leftAmount = 0;
      newUpdatedSh = newUpdatedSh.map((item) => {
        const amountData = defaultData["Share Holders"]?.value?.find(
          (val) => val.id == item.value.id
        );
        leftAmount += parseFloat(amountData.amount);
        return {
          ...item,
          value: {
            ...item.value,
            transAmount: parseFloat(amountData.amount),
          },
        };
      });
      setRemainingAmount(parseFloat((parseFloat(formData.amount) - leftAmount).toFixed(2)));
      setSelectedShareHolder(newUpdatedSh);
      setShareHolderOption(
        getOpt?.filter((item) => !shIds?.includes(item.value.id))
      );
    } else {
      setShareHolderOption(getOpt);
    }
  }, [props.shareholdersList]);

  useEffect(() => {
    const getOpt = optionForInvoice();
    if (isUpdate) {
      let invoicesIds = defaultData["Invoices"]?.value?.map((item) => item.id);
      let newUpdatedInvoice = getOpt?.filter((item) =>
        invoicesIds.includes(item.value.id)
      );
      let leftAmount = 0;
      newUpdatedInvoice = newUpdatedInvoice.map((item) => {
        const amountData = defaultData["Invoices"]?.value?.find(
          (val) => val.id == item.value.id
        );
        leftAmount += parseFloat(amountData.amount);
        return {
          ...item,
          value: {
            ...item.value,
            transInvoiceAmount: parseFloat(amountData.amount),
          },
        };
      });
      setInvoiceRemainingAmount(parseFloat(formData.amount) - leftAmount);
      setSelectedInvoices(newUpdatedInvoice);
      setInvoicesOption(
        getOpt?.filter((item) => !invoicesIds?.includes(item.value.id))
      );
    } else {
      setInvoicesOption(getOpt);
    }
  }, [props.invoicesList]);

  useEffect(() => {
    const getOpt = optionForSpends();
    console.log(getOpt);
    if (isUpdate) {
      let spendsId = defaultData["spendList"]?.value?.map((item) => item.id);
      let newUpdatedSpends = getOpt?.filter((item) =>
        spendsId.includes(item.value.id)
      );
      let leftAmount = 0;
      newUpdatedSpends = newUpdatedSpends.map((item) => {
        const amountData = defaultData["spendList"]?.value?.find(
          (val) => val.id == item.value.id
        );
        leftAmount += parseFloat(amountData.amount);
        return {
          ...item,
          value: {
            ...item.value,
            transSpendAmount: parseFloat(amountData.amount),
          },
        };
      });
      setSpendRemainingAmount(parseFloat(formData.amount) - leftAmount);
      setSelectedSpends(newUpdatedSpends);
      setSpendsOption(
        getOpt?.filter((item) => !spendsId?.includes(item.value.id))
      );
    } else {
      setSpendsOption(getOpt);
    }
  }, [props.spendList]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((preVal) => ({
      ...preVal,
      [name]: value,
    }));
  };

  // Check For Empty Fields
  const checkEmptyField = () => {
    if (
      formData.description == "" ||
      formData.amount == "" ||
      formData.type == "" ||
      formData.transaction_date == null
    ) {
      toast.error("Please Fill All Fields");
      return true;
    }
    if (formData.amount < 0) {
      toast.error("Amount should be greater than zero.");
      return true;
    }
    const amountSum = selectedShareHolder.reduce((total, sholders) => {
      return total + (parseFloat(sholders.value.transAmount) || 0);
    }, 0);
    const amountInvoiceSum = selectedInvoices.reduce((total, invoice) => {
      return total + (parseFloat(invoice.value.transInvoiceAmount) || 0);
    }, 0);
    const amountSpendsSum = selectedSpends.reduce((total, spend) => {
      return total + (parseFloat(spend.value.transSpendAmount) || 0);
    }, 0);
    if (formData.amount < amountSum || formData.amount < amountInvoiceSum || formData.amount < amountSpendsSum) {
      toast.error("Invalid Amount, Please Enter Valid Amount");
      return true;
    }
    return false;
  };

  // CREATE/UPDATE Transactions
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (checkEmptyField()) return;
    try {
      if (!isUpdate) {
        const newShareholders = selectedShareHolder.map((item) => ({
          shareholder_id: item.value.id,
          amount: parseFloat(item.value.transAmount),
        }));
        const newInvoices = selectedInvoices.map((item) => ({
          invoice_id: item.value.id,
          amount: parseFloat(item.value.transInvoiceAmount),
        }));
        const newSpend = selectedSpends.map((item) => ({
          spend_id: item.value.id,
          amount: parseFloat(item.value.transSpendAmount),
        }));
        let newPostData = {
          ...formData,
          type: formData.type?.value,
          transaction_date: formData.transaction_date, //format(formData.transaction_date, "yyyy-MM-dd"),
          transactionShareHolderMap: [...newShareholders],
          transactionInvoiceMap: [...newInvoices],
        };
        // If there are debit transaction then spend would be added
        formData.type?.value == "debit"
          ? (newPostData = {
            ...newPostData,
            transactionSpendMap: [...newSpend],
          })
          : newPostData;

        await props.addTransaction(newPostData);
        setFormData(initialDataFormData);
        setSelectedShareHolder([]);
        setSelectedInvoices([]);
        setSelectedSpends([]);
      } else {
        let newSh = [], updateSh = [];
        let newIn = [], updateIn = [];
        let newSp = [], updateSp = [];

        // Formatting For Each Shareholder
        const allSelectedSh = selectedShareHolder.map((item) => item.value);
        const deletedShIds = deletedShareHolder.map(
          (item) => item.shareholder_id
        );
        allSelectedSh.map((item) => {
          const isPresentInDeleted = deletedShIds.includes(item.id);
          if (isPresentInDeleted) {
            newSh.push({ shareholder_id: item.id, amount: item.transAmount });
          } else {
            const detailsData = props.transactionsList?.find(
              (val) => val.id === defaultData?.transactionId?.value
            );
            // If this id present in alredy presented data then it going to update else Create
            const isGoingToUpdate = detailsData.transactionShareHolderMap?.find(
              (val) => val.shareholder_id === item.id
            );
            if (isGoingToUpdate) {
              updateSh.push({
                id: isGoingToUpdate.id,
                shareholder_id: item.id,
                amount: item.transAmount,
              });
            } else {
              newSh.push({ shareholder_id: item.id, amount: item.transAmount });
            }
          }
        });

        // Formatting For Each Invoices
        const allSelectedIn = selectedInvoices.map(item => item.value);
        const deletedInIds = deletedInvoices.map(item => item.invoice_id);
        allSelectedIn.map((item) => {
          const isPresentInDeleted = deletedInIds.includes(item.id);
          if (isPresentInDeleted) {
            newIn.push({ invoice_id: item.id, amount: item.transInvoiceAmount });
          } else {
            const detailsData = props.transactionsList?.find(
              (val) => val.id === defaultData?.transactionId?.value
            );
            const isGoingToUpdate = detailsData.transactionInvoiceMap?.find(
              (val) => val.invoice_id === item.id
            );
            if (isGoingToUpdate) {
              updateIn.push({
                id: isGoingToUpdate.id,
                invoice_id: item.id,
                amount: item.transInvoiceAmount,
              });
            } else {
              newIn.push({ invoice_id: item.id, amount: item.transInvoiceAmount });
            }
          }
        })

        // Formatting For Each Spends
        const allSelectedSp = selectedSpends.map(item => item.value);
        const deletedSpIds = deletedSpends.map(item => item.spend_id);
        allSelectedSp.map((item) => {
          const isPresentInDeleted = deletedSpIds.includes(item.id);
          if (isPresentInDeleted) {
            newSp.push({ spend_id: item.id, amount: item.transSpendAmount });
          } else {
            const detailsData = props.transactionsList?.find(
              (val) => val.id === defaultData?.transactionId?.value
            );
            const isGoingToUpdate = detailsData.transactionSpendMap?.find(
              (val) => val.spend_id === item.id
            );
            if (isGoingToUpdate) {
              updateSp.push({
                id: isGoingToUpdate.id,
                spend_id: item.id,
                amount: item.transSpendAmount,
              });
            } else {
              newSp.push({ spend_id: item.id, amount: item.transSpendAmount });
            }
          }
        })
        // Data For Creation
        let postData = {
          ...formData,
          type: formData.type?.value,
          transaction_date:  formData.transaction_date, //format(formData.transaction_date, "yyyy-MM-dd"),
          transactionShareHolderMap: [
            ...newSh,
            ...updateSh,
            ...deletedShareHolder,
          ],
          transactionInvoiceMap: [...newIn, ...updateIn, ...deletedInvoices],
        };
        // If Type = Debit then Spend would be added
        formData.type?.value == "debit"
          ? (postData = {
            ...postData,
            transactionSpendMap: [...newSp, ...updateSp, ...deletedSpends],
          })
          : postData;
        await props.updateTransaction(
          { ...postData, id: defaultData?.transactionId?.value },
          defaultData?.transactionId?.value
        );
      }
    } catch (error) {
      console.log("Error While Adding Transaction :", error);
    }
  };

  // Shareholder Deletion
  const handleDeleteShareholder = (valueToDelete) => {
    if (isUpdate) {
      let isDataPresent = defaultData["Share Holders"]?.value?.find(
        (item) => item.id === valueToDelete.value.id
      );
      if (isDataPresent) {
        // const isValueChanged = parseFloat(isDataPresent.amount)===parseFloat(valueToDelete.value.transAmount) ? false : true;
        const detailsOfTrans = props.transactionsList.find(
          (item) => item.id === defaultData?.transactionId.value
        );
        const detailsOfShTrans =
          detailsOfTrans?.transactionShareHolderMap?.find(
            (val) => val.shareholder_id === valueToDelete.value.id
          );
        // if(isValueChanged===false){
        let deleteField = {
          id: detailsOfShTrans.id,
          transaction_id: detailsOfShTrans.transaction_id,
          shareholder_id: detailsOfShTrans.shareholder_id,
          amount: detailsOfShTrans.amount,
          deleted_at: new Date(),
        };
        setDeletedShareHolder((preVal) => [...preVal, deleteField]);
        // }
      }
    }
    const filteredShareholder = selectedShareHolder.filter(
      (item) => item.value.id !== valueToDelete.value.id
    );
    setSelectedShareHolder(filteredShareholder);
    setRemainingAmount(
      remainingAmount + parseFloat(valueToDelete.value.transAmount)
    );
    const aleredyPresentShareholder = shareHolderOption.some(
      (item) => item.value.id === valueToDelete.value.id
    );
    if (aleredyPresentShareholder === false) {
      shareHolderOption = shareHolderOption || [];
      valueToDelete.value.transAmount = 0;
      let data = [...shareHolderOption, valueToDelete];
      let sortedData = data.sort((a, b) => a.value.id - b.value.id);
      setShareHolderOption(sortedData);
    }
  };
  const handleDeleteInvoice = (valueToDelete) => {
    if (isUpdate) {
      let isDataPresent = defaultData["Invoices"]?.value?.find(
        (item) => item.id === valueToDelete.value.id
      );
      if (isDataPresent) {
        // const isValueChanged = parseFloat(isDataPresent.amount)===parseFloat(valueToDelete.value.transAmount) ? false : true;
        const detailsOfTrans = props.transactionsList.find(
          (item) => item.id === defaultData?.transactionId.value
        );
        const detailsOfInvoiceTrans =
          detailsOfTrans?.transactionInvoiceMap?.find(
            (val) => val.invoice_id === valueToDelete.value.id
          );
        // if(isValueChanged===false){
        let deleteField = {
          id: detailsOfInvoiceTrans.id,
          transaction_id: detailsOfInvoiceTrans.transaction_id,
          invoice_id: detailsOfInvoiceTrans.invoice_id,
          amount: detailsOfInvoiceTrans.amount,
          deleted_at: new Date(),
        };
        setDeletedInvoices((preVal) => [...preVal, deleteField]);
        // }
      }
    }
    const filteredInvoices = selectedInvoices.filter(
      (item) => item.value.id !== valueToDelete.value.id
    );

    setSelectedInvoices(filteredInvoices);
    setInvoiceRemainingAmount(
      invoiceRemainingAmount + parseFloat(valueToDelete.value.transInvoiceAmount)
    );
    const aleredyPresentInvoices = invoicesOption.some(
      (item) => item.value.id === valueToDelete.value.id
    );
    if (aleredyPresentInvoices === false) {
      invoicesOption = invoicesOption || [];
      valueToDelete.value.transInvoiceAmount = 0;
      let data = [...invoicesOption, valueToDelete];
      let sortedData = data.sort((a, b) => a.value.id - b.value.id);
      setInvoicesOption(sortedData);
    }
  };
  const handleDeleteSpends = (valueToDelete) => {
    if (isUpdate) {
      let isDataPresent = defaultData["spendList"]?.value?.find(
        (item) => item.id === valueToDelete.value.id
      );
      if (isDataPresent) {
        // const isValueChanged = parseFloat(isDataPresent.amount)===parseFloat(valueToDelete.value.transAmount) ? false : true;
        const detailsOfTrans = props.transactionsList.find(
          (item) => item.id === defaultData?.transactionId.value
        );
        const detailsOfSpendsTrans =
          detailsOfTrans?.transactionSpendMap?.find(
            (val) => val.spend_id === valueToDelete.value.id
          );
        // if(isValueChanged===false){
        let deleteField = {
          id: detailsOfSpendsTrans.id,
          transaction_id: detailsOfSpendsTrans.transaction_id,
          spend_id: detailsOfSpendsTrans.spend_id,
          amount: detailsOfSpendsTrans.amount,
          deleted_at: new Date(),
        };
        setDeletedSpends((preVal) => [...preVal, deleteField]);
        // }
      }
    }
    const filteredSpends = selectedSpends.filter(
      (item) => item.value.id !== valueToDelete.value.id
    );

    setSelectedSpends(filteredSpends);
    setSpendRemainingAmount(
      spendRemainingAmount + parseFloat(valueToDelete.value.transSpendAmount)
    );
    const aleredyPresentSpends = spendsOption.some(
      (item) => item.value.id === valueToDelete.value.id
    );
    if (aleredyPresentSpends === false) {
      spendsOption = spendsOption || [];
      valueToDelete.value.transSpendAmount = 0;
      let data = [...spendsOption, valueToDelete];
      let sortedData = data.sort((a, b) => a.value.id - b.value.id);
      setSpendsOption(sortedData);
    }
  };

  // Individual Shareholder Amount handle
  const handleAmountChange = (e, selectedVal) => {
    const formAmount = parseFloat(formData.amount);

    const sumOfAmount = selectedShareHolder.reduce((total, sholders) => {
      if (sholders.value.id !== selectedVal.value.id) {
        return total + parseFloat(sholders.value.transAmount);
      }
      return total;
    }, 0);
    if (!formAmount) {
      toast.error("Please Enter Transaction Amount");
      return;
    }
    if (sumOfAmount + parseFloat(e.target.value) > formAmount) {
      toast.error(`You Exceed Maximum Limit`);
      return;
    }
    const updatedShareholderAmount = selectedShareHolder.map((item) => {
      if (item.value.id === selectedVal.value.id) {
        return {
          ...item,
          value: {
            ...item.value,
            transAmount: parseFloat(e.target.value),
          },
        };
      }
      return item;
    });
    setSelectedShareHolder(updatedShareholderAmount);
    const amountSumAfter = updatedShareholderAmount.reduce(
      (total, sholders) => {
        return total + (parseFloat(sholders.value.transAmount) || 0);
      },
      0
    );

    setRemainingAmount(formAmount - amountSumAfter);
    setShareHolderOption(
      shareHolderOption.filter((item) => item.value.id !== selectedVal.value.id)
    );
    console.log(parseFloat(formData.amount), "<== Parse Integer Amount");
  };
  const handleInvoiceAmountChange = (e, selectedVal) => {
    const formAmount = parseFloat(formData.amount);

    const sumOfAmount = selectedInvoices.reduce((total, invoice) => {
      if (invoice.value.id !== selectedVal.value.id) {
        return total + parseFloat(invoice.value.transInvoiceAmount);
      }
      return total;
    }, 0);
    if (!formAmount) {
      toast.error("Please Enter Transaction Amount");
      return;
    }
    if (sumOfAmount + parseFloat(e.target.value) > formAmount) {
      toast.error(`You Exceed Maximum Limit`);
      return;
    }
    const updatedInvoicesAmount = selectedInvoices.map((item) => {
      if (item.value.id === selectedVal.value.id) {
        return {
          ...item,
          value: {
            ...item.value,
            transInvoiceAmount: parseFloat(e.target.value),
          },
        };
      }
      return item;
    });
    setSelectedInvoices(updatedInvoicesAmount);
    const amountSumAfter = updatedInvoicesAmount.reduce(
      (total, invoice) => {
        return total + (parseFloat(invoice.value.transInvoiceAmount) || 0);
      },
      0
    );

    setInvoiceRemainingAmount(formAmount - amountSumAfter);
    setInvoicesOption(
      invoicesOption.filter((item) => item.value.id !== selectedVal.value.id)
    );
  };
  const handleSpendAmountChange = (e, selectedVal) => {
    const formAmount = parseFloat(formData.amount);

    const sumOfAmount = selectedSpends.reduce((total, spend) => {
      if (spend.value.id !== selectedVal.value.id) {
        return total + parseFloat(spend.value.transSpendAmount);
      }
      return total;
    }, 0);
    if (!formAmount) {
      toast.error("Please Enter Transaction Amount");
      return;
    }
    if (sumOfAmount + parseFloat(e.target.value) > formAmount) {
      toast.error(`You Exceed Maximum Limit`);
      return;
    }
    const updatedSpendsAmount = selectedSpends.map((item) => {
      if (item.value.id === selectedVal.value.id) {
        return {
          ...item,
          value: {
            ...item.value,
            transSpendAmount: parseFloat(e.target.value),
          },
        };
      }
      return item;
    });
    setSelectedSpends(updatedSpendsAmount);
    const amountSumAfter = updatedSpendsAmount.reduce(
      (total, spend) => {
        return total + (parseFloat(spend.value.transSpendAmount) || 0);
      },
      0
    );
    setSpendRemainingAmount(formAmount - amountSumAfter);
    setSpendsOption(
      spendsOption.filter((item) => item.value.id !== selectedVal.value.id)
    );
  };

  return (
    <Sidebarlayout>
      <div className="addTransaction-main">
        <div className="page-title">
          <h4> {isUpdate ? "Update" : "Add"} Transacction</h4>
          <div className="edit-btn">
            <button className="custom-btn" onClick={handleSubmit}>
              {props.loading ? (
                <Spinner
                  as="span"
                  animation="border"
                  size="sm"
                  role="status"
                  aria-hidden="true"
                />
              ) : (
                "save"
              )}
            </button>
          </div>
        </div>
        <div className="content-part">
          <div className="row">
            <div className="col-lg-6">
              <div className="left-part">
                <div className="custom-row">
                  <div className="row">
                    <div className="col-lg-4">
                      <div className="type">
                        <h6 className="label">Transaction type</h6>
                        <Select
                          options={optionType}
                          styles={customStyle}
                          isDisabled={props.loading}
                          theme={(theme) => ({
                            ...theme,
                            colors: {
                              ...theme.colors,
                              primary25: "#5757fe",
                              primary: "#5757fe",
                            },
                          })}
                          name="type"
                          value={formData.type}
                          onChange={(val) => {
                            setFormData((preVal) => ({
                              ...preVal,
                              type: val,
                            }));
                          }}
                        />
                      </div>
                    </div>
                    <div className="col-lg-4">
                      <div className="amount">
                        <h6 className="label">Amount</h6>
                        <input
                          className="input-css"
                          type="number"
                          disabled={props.loading}
                          value={formData.amount}
                          onChange={(e) => {
                            if (e.target.value < 0) {
                              toast.error("Enter Valid Amount");
                              return;
                            }
                            const amountSumAfter = selectedShareHolder.reduce(
                              (total, sholders) => {
                                return (
                                  total +
                                  (parseFloat(sholders.value.transAmount) || 0)
                                );
                              },
                              0
                            );
                            const amountInvoiceSum = selectedInvoices.reduce((total, invoice) => {
                              return (total + (parseFloat(invoice.value.transInvoiceAmount) || 0))
                            }, 0);
                            const amountSpendSum = selectedSpends.reduce((total, spend) => {
                              return (total + (parseFloat(spend.value.transSpendAmount) || 0))
                            }, 0);
                            setRemainingAmount(parseFloat(e.target.value) - amountSumAfter);
                            setInvoiceRemainingAmount(parseFloat(e.target.value) - amountInvoiceSum);
                            setSpendRemainingAmount(parseFloat(e.target.value) - amountSpendSum);

                            handleChange(e);
                          }}
                          name="amount"
                        />
                      </div>
                    </div>
                    <div className="col-lg-4">
                      <div className="type">
                        <h6 className="label">Transaction Date</h6>
                        {console.log(formData.transaction_date)}
                        <DatePicker
                          styles={customStyle}
                          isDisabled={props.loading}
                          theme={(theme) => ({
                            ...theme,
                            colors: {
                              ...theme.colors,
                              primary25: "#5757fe",
                              primary: "#5757fe",
                            },
                          })}
                          selected={formData.transaction_date}
                          name="transaction_date"
                          dateFormat="yyyy-MM-dd"
                          onChange={(date) => {
                            setFormData((preVal) => ({
                              ...preVal,
                              transaction_date: date,
                            }));
                          }}
                        />
                      </div>
                    </div>
                    <div className="col-lg-12">
                      <div className="description">
                        <h6 className="label">Description</h6>
                        <input
                          className="input-css"
                          type="text"
                          name="description"
                          id="description"
                          value={formData.description}
                          onChange={handleChange}
                          disabled={props.loading}
                        ></input>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="custom-row">
                  <div className="shareholder">
                    <h5 className="label">Share Holder</h5>
                    <p className="desc-text">
                      Remaining Amount : {remainingAmount || 0}
                    </p>
                    <Select
                      isMulti
                      disabled={props.loading}
                      styles={customStyle}
                      options={shareHolderOption || []}
                      value={selectedShareHolder}
                      onChange={(value) => {
                        if (remainingAmount <= 0) return;
                        value[value.length - 1].value.transAmount = remainingAmount;
                        setRemainingAmount(0);
                        setSelectedShareHolder(value)
                      }}
                      controlShouldRenderValue={false}
                      theme={(theme) => ({
                        ...theme,
                        colors: {
                          ...theme.colors,
                          primary25: "#5757fe",
                          primary: "#5757fe",
                        },
                      })}
                    />
                    <ul className="ListMenu">
                      {selectedShareHolder &&
                        selectedShareHolder?.map((selectedValue, index) => {
                          return (
                            <li key={index}>
                              {selectedValue.label}
                              <div className="second-part-list">
                                <span style={{ whiteSpace: "nowrap" }}>
                                  Amount :{" "}
                                </span>
                                &nbsp;
                                <input
                                  type="number"
                                  className="input-css"
                                  value={selectedValue.value.transAmount}
                                  min={0}
                                  defaultValue={0}
                                  placeholder="Amount"
                                  name="sh-amount"
                                  style={{
                                    width: "150px",
                                  }}
                                  onChange={(e) =>
                                    handleAmountChange(e, selectedValue)
                                  }
                                />{" "}
                                &nbsp;
                                <FaTrashAlt
                                  className="deleteIcon"
                                  onClick={() =>
                                    handleDeleteShareholder(selectedValue)
                                  }
                                />
                              </div>
                            </li>
                          );
                        })}
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="right-part">
                <div className="invoice">
                  <h5 className="label">Invoices</h5>
                  <p className="desc-text">
                    Remaining Amount : {invoiceRemainingAmount || 0}
                  </p>
                  <Select
                    options={invoicesOption || []}
                    isMulti
                    onChange={(value) => {
                      if (invoiceRemainingAmount <= 0) return;
                      value[value.length - 1].value.transInvoiceAmount = invoiceRemainingAmount;
                      setInvoiceRemainingAmount(0);
                      setSelectedInvoices(value)
                    }
                    }
                    controlShouldRenderValue={false}
                    value={selectedInvoices}
                    styles={customStyle}
                    disabled={props.loading}
                    theme={(theme) => ({
                      ...theme,
                      colors: {
                        ...theme.colors,
                        primary25: "#5757fe",
                        primary: "#5757fe",
                      },
                    })}
                  />
                  <ul className="ListMenu">
                    {selectedInvoices &&
                      selectedInvoices?.map((selectedValue, index) => {
                        return (
                          <li key={index}>
                            {selectedValue.label}
                            <div className="second-part-list">
                              <span style={{ whiteSpace: "nowrap" }}>
                                Amount :{" "}
                              </span>
                              &nbsp;
                              <input
                                type="number"
                                className="input-css"
                                value={selectedValue.value.transInvoiceAmount}
                                min={0}
                                defaultValue={0}
                                placeholder="Amount"
                                name="sh-amount"
                                style={{
                                  width: "150px",
                                }}
                                onChange={(e) =>
                                  handleInvoiceAmountChange(e, selectedValue)
                                }
                              />{" "}
                              &nbsp;
                              <FaTrashAlt
                                className="deleteIcon"
                                onClick={() =>
                                  handleDeleteInvoice(selectedValue)
                                }
                              />
                            </div>
                          </li>
                        );
                      })}
                  </ul>
                </div>
                {formData?.type?.value === "debit" ? (
                  <div className="spends">
                    <h5 className="label">Spends</h5>
                    <p className="desc-text">
                      Remaining Amount : {spendRemainingAmount || 0}
                    </p>
                    <Select
                      options={spendsOption || []}
                      value={selectedSpends}
                      onChange={(value) => {
                        if (spendRemainingAmount <= 0) return;
                        value[value.length - 1].value.transSpendAmount = spendRemainingAmount;
                        setSpendRemainingAmount(0);
                        setSelectedSpends(value);
                      }}
                      controlShouldRenderValue={false}
                      isMulti
                      styles={customStyle}
                      disabled={props.loading}
                      theme={(theme) => ({
                        ...theme,
                        colors: {
                          ...theme.colors,
                          primary25: "#5757fe",
                          primary: "#5757fe",
                        },
                      })}
                    />
                    <ul className="ListMenu">
                      {selectedSpends &&
                        selectedSpends?.map((selectedValue, index) => {
                          return (
                            <li key={index}>
                              {selectedValue.label}
                              <div className="second-part-list">
                                <span style={{ whiteSpace: "nowrap" }}>
                                  Amount :{" "}
                                </span>
                                &nbsp;
                                <input
                                  type="number"
                                  className="input-css"
                                  value={selectedValue.value.transSpendAmount}
                                  min={0}
                                  defaultValue={0}
                                  placeholder="Amount"
                                  name="sh-amount"
                                  style={{
                                    width: "150px",
                                  }}
                                  onChange={(e) =>
                                    handleSpendAmountChange(e, selectedValue)
                                  }
                                />{" "}
                                &nbsp;
                                <FaTrashAlt
                                  className="deleteIcon"
                                  onClick={() =>
                                    handleDeleteSpends(selectedValue)
                                  }
                                />
                              </div>
                            </li>
                          );
                        })}
                    </ul>
                  </div>
                ) : null}
              </div>
            </div>
          </div>
        </div>
      </div>
    </Sidebarlayout>
  );
};
const mapStateToProps = (state) => {
  return {
    shareholdersList: state.shareholdersReducer.shareholderslist,
    spendList: state.spendReducer.spendList,
    loading: state.transactionReducers.loading,
    invoicesList: state.invoicesReducer.invoiceslist,
    transactionsList: state.transactionReducers.transactions.rows,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getShareholdersList: () => {
      dispatch(getShareholdersList());
    },
    getSpendList: () => {
      dispatch(getSpendList());
    },
    getInvoicesList: () => {
      dispatch(getInvoicesList());
    },
    addTransaction: (postData) => {
      dispatch(addTransaction(postData));
    },
    updateTransaction: (postData, id) => {
      dispatch(updateTransaction(postData, id));
    },
  };
};
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AddUpdateTransaction);
